// ---------- Message for console viewers ;)  ----------
console.log(
    "%cMet online voorsprong gerealiseerd! %c\u2764 %cDoorbijters",
    "display: inline-block; border-radius: 40px 0px 0px 40px ; " +
    "border-left:1px solid #DD114A; border-top:1px solid #DD114A; border-bottom:1px solid #DD114A;" +
    "padding: 4px 0px 4px 15px; margin: 7px 0px 7px 7px;" +
    "background: #10182C ; color: white; " +
    "font-size: 12px ; ",
    "display: inline-block; border-radius: 0px ; " +
    "border-top:1px solid #DD114A; border-bottom:1px solid #DD114A;" +
    "padding: 4px 0px 4px 0px; margin: 7px 0px 7px 0px;" +
    "background: #10182C ; color: #DD114A; " +
    "font-size: 12px ; ",
    "display: inline-block ;  border-radius: 0px 40px 40px 0px ; " +
    "border-right:1px solid #DD114A; border-top:1px solid #DD114A; border-bottom:1px solid #DD114A;" +
    "padding: 4px 15px 4px 0px; margin: 7px 0px 7px 0px;" +
    "background: #10182C ; color: white; " +
    "font-size: 12px ; ",
);

/**
 * Doorbijters Theme - Main JavaScript Entry
 * ==========================================
 * This file bundles all non-critical JavaScript.
 * Critical JS for above-the-fold content should go in critical.js
 *
 * Structure:
 *   src/js/components/       — general site JS (header, etc.), organised per folder
 *   src/js/elementor/  — Elementor widget JS
 */

// ── Site-wide modules ───────────────────────────────────────────────────────
import './components/lenis.js';
import './components/mobile-nav.js';
import './components/parallax.js';
import './components/store-card.js';
import './components/floating-labels.js';
// Random images handled in PHP to avoid load flicker

// ── Elementor widget modules ────────────────────────────────────────────────
import './elementor/widgets/steps-vertical.js';
import './elementor/widgets/marquee.js';
// import './elementor/widgets/hero.js';

// ── Window resize handler for responsive JS refresh ──────────────────────────
let resizeTimeout;
window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
        // Dispatch custom event for components to listen to
        window.dispatchEvent(new Event('responsiveResize'));
    }, 250); // Debounce to avoid excessive calls
});

